<template>
  <v-card>
    <v-card-title>
      <div>
        Single Notification<br /><small>{{ "Time Zone: " + TIME_ZONE }}</small>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="red"
        @click="confirmDelete()"
        class="mr-2"
        :disabled="!selectedSingleNotification.length"
      >
        Delete Selected ({{ selectedSingleNotification.length }})
        <v-icon right>mdi-delete</v-icon>
      </v-btn>
      <v-btn color="primary" @click="addNotification">
        Add
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
      class="px-4 pb-4"
    ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="notificationItems"
      :loading="isNotificationPending"
      :search="search"
      v-model="selectedSingleNotification"
      show-select
    >
      <template v-slot:item.scheduledAt="{ value }">
        {{
          value
            ? DateTime.fromISO(value, { zone: TIME_ZONE }).toFormat(
                "yyyy-MM-dd HH:mm"
              )
            : "N/A"
        }}
      </template>
      <template v-slot:item.sentAt="{ value }">
        {{
          value
            ? DateTime.fromISO(value, { zone: TIME_ZONE }).toFormat(
                "yyyy-MM-dd HH:mm"
              )
            : "N/A"
        }}
      </template>
      <template v-slot:item.createdAt="{ value }">
        {{
          DateTime.fromISO(value, { zone: TIME_ZONE }).toFormat(
            "yyyy-MM-dd HH:mm"
          )
        }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn color="red" dark class="ma-2" @click="confirmDelete(item)">
          Delete
          <v-icon right>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="showAddDialog" max-width="600px" persistent scrollable>
      <v-card>
        <v-card-title>
          Notification
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col class="pa-0">
                <v-file-input
                  outlined
                  prepend-icon=""
                  prepend-inner-icon="$file"
                  accept=".xlsx, .xls, .csv"
                  label="Import File"
                  placeholder="Click to Select..."
                  :messages="excelUploadStatus"
                  @click:clear="cancelUploadExcel"
                  v-model="selectedExcelFile"
                  @change="uploadExcel"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row v-show="stage >= 1">
              <v-col class="pb-0 px-0">
                Field Mapping
              </v-col>
            </v-row>
            <v-row v-show="stage >= 1">
              <v-col class="pl-0">
                <v-select
                  v-model="selectedExcelHeader"
                  :items="excelHeaders"
                  item-text="text"
                  item-value="value"
                  label="Field in Excel"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col class="pr-0">
                <v-select
                  v-model="selectedGuestHeader"
                  :items="availableGuestHeaders"
                  item-text="text"
                  item-value="value"
                  label="Field in Guest"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-show="stage >= 2">
              <v-col class="pb-0 px-0">
                Select Notification Field
              </v-col>
            </v-row>
            <v-row v-show="stage >= 2">
              <v-col class="pl-0">
                <v-select
                  v-model="selectedNotificationTitleHeader"
                  :items="excelHeaders"
                  item-text="text"
                  item-value="value"
                  label="Title"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  v-model="selectedNotificationContentHeader"
                  :items="excelHeaders"
                  item-text="text"
                  item-value="value"
                  label="Content"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
              <v-col class="pr-0">
                <v-select
                  v-model="selectedNotificationScheduledAtHeader"
                  :items="excelHeaders"
                  item-text="text"
                  item-value="value"
                  label="Scheduled At"
                  outlined
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-show="stage >= 3">
              <v-col class="pb-0 px-0">
                Preview Notification
              </v-col>
            </v-row>
            <v-row v-show="stage >= 3">
              <v-col class="px-0">
                <v-data-table
                  :headers="previewHeaders"
                  :items="currentNotificationArray"
                ></v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary" @click="cancelAddNotification">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="confirmSave"
            :disabled="!enableSaveButton"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <PopupAlert
      v-model="showSaveDialog"
      title="Confirm"
      message="Do you want to schedule your notification?"
      :onYes="saveNotification"
      :onNo="cancelSave"
    >
    </PopupAlert>
    <PopupAlert
      v-model="showDeleteDialog"
      title="Confirm"
      message="Do you want to cancel your notification?"
      :onYes="deleteNotification"
      :onNo="cancelDelete"
    >
    </PopupAlert>
    <v-overlay z-index="999" :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<style scoped></style>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { DateTime } from "luxon";
import XLSX from "xlsx";
import PopupAlert from "../../components/PopupAlert";
import eConfig from "../../evention-config";
import axios from "axios";

export default {
  name: "EventSingleNotification",
  components: { PopupAlert },
  setup(props, { root }) {
    // constants
    const TIME_ZONE = "Asia/Hong_Kong";

    // page variables
    const eventId = computed(() => root.$route.params.eventId);
    const overlay = ref(false);
    const showAddDialog = ref(false);
    const showSaveDialog = ref(false);
    const showDeleteDialog = ref(false);
    const stage = ref(0);

    // handle data table
    const { SingleNotification } = root.$FeathersVuex.api;
    const notificationItems = ref([]);
    const isNotificationPending = ref(false);

    const fetchNotification = async function() {
      isNotificationPending.value = true;
      const result = await SingleNotification.find({
        query: {
          eventId: eventId.value,
          $sort: { scheduledAt: -1 },
        },
      });
      notificationItems.value = result.data;
      isNotificationPending.value = false;
    };

    onMounted(() => {
      fetchNotification();
    });

    const headers = ref([
      { text: "Scheduled At", value: "scheduledAt" },
      { text: "Sent At", value: "sentAt" },
      { text: "Title", value: "title" },
      { text: "Content", value: "content" },
      { text: "Event Guest", value: "eventGuest.ev_email" },
      { text: "Created At", value: "createdAt" },
      { text: "", value: "actions" },
    ]);
    const selectedSingleNotification = ref([]);

    // stage 1
    // handle excel upload
    const selectedExcelFile = ref(null);
    const excelHeaders = ref([]);
    const excelData = ref([]);
    const excelUploading = ref(false);
    const excelUploadStatus = ref("Please upload an Excel file");
    const guestList = ref([]);

    // excel upload status message
    const animationInterval = ref(null);
    watch(excelUploading, (val) => {
      if (val) {
        let i = 1;
        animationInterval.value = setInterval(() => {
          excelUploadStatus.value = "Processing" + ".".repeat(i);
          i++;
          if (i > 3) i = 1;
        }, 1000);
      } else {
        clearInterval(animationInterval.value);
      }
    });

    // read excel to memory
    const readXLSX = (file) => {
      let nameSplit = file.name.split(".");
      let format = nameSplit[nameSplit.length - 1];
      if (!["xls", "xlsx", "csv"].includes(format)) {
        return false;
      }
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onerror = () => {
          reject(new Error("Failed to read file"));
        };

        reader.onload = function(evt) {
          try {
            let data = evt.target.result;
            var workbook = XLSX.read(data, { type: "array" });
            let outdata = XLSX.utils.sheet_to_json(
              workbook.Sheets[workbook.SheetNames[0]],
              { defval: "" }
            );
            resolve(outdata);
          } catch (error) {
            reject(new Error("Failed to parse Excel file: " + error.message));
          }
        };
      });
    };
    const uploadExcel = async (f) => {
      if (f) {
        try {
          excelUploading.value = true;

          const outdata = await readXLSX(f);
          excelData.value = outdata;

          if (excelData.value && excelData.value.length >= 1) {
            excelHeaders.value = Object.keys(excelData.value[0]).map((col) => {
              return { text: col, value: col };
            });
          }

          // preload guest data
          const { EventGuest } = root.$FeathersVuex.api;
          const { data: guestItems } = await EventGuest.find({
            query: {
              eventId: eventId.value,
              $sort: {
                ev_firstname: 1,
                ev_lastname: 1,
              },
            },
          });
          guestList.value = guestItems;

          // clear stage 2 data
          selectedGuestHeader.value = null;
          selectedExcelHeader.value = null;
          // clear stage 3 data
          selectedNotificationTitleHeader.value = null;
          selectedNotificationContentHeader.value = null;
          selectedNotificationScheduledAtHeader.value = null;
          currentNotificationArray.value = [];
          enableSaveButton.value = false;

          await root.$nextTick();
          stage.value = 1;

          excelUploading.value = false;
          excelUploadStatus.value = "Uploaded";
        } catch (error) {
          root.$store.dispatch("showSnackBar", error.message);
        }
      } else {
        return false;
      }
    };

    // stage 2
    // handle excel mapping
    const selectedGuestHeader = ref(null);
    const selectedExcelHeader = ref(null);
    const availableGuestHeaders = computed(() => {
      return Object.entries(eConfig.ev_guest.dbColMapping).map(
        ([key, value]) => {
          return { text: key, value: value };
        }
      );
    });
    const mappingSelected = computed(() => {
      return selectedGuestHeader.value && selectedExcelHeader.value;
    });

    watch([mappingSelected], (val) => {
      if (val) {
        stage.value = 2;
      }
    });

    // stage 3
    const selectedNotificationTitleHeader = ref(null);
    const selectedNotificationContentHeader = ref(null);
    const selectedNotificationScheduledAtHeader = ref(null);
    const notificationHeaderSelected = computed(() => {
      return (
        selectedNotificationTitleHeader.value &&
        selectedNotificationContentHeader.value &&
        selectedNotificationScheduledAtHeader.value
      );
    });
    const currentNotificationArray = ref([]);

    watch([mappingSelected, notificationHeaderSelected], () => {
      if (mappingSelected.value && notificationHeaderSelected.value) {
        stage.value = 3;
        currentNotificationArray.value = [];
        excelData.value.forEach((row) => {
          guestList.value.forEach((guest) => {
            if (
              row[selectedExcelHeader.value] == guest[selectedGuestHeader.value]
            ) {
              currentNotificationArray.value.push({
                eventId: eventId.value,
                eventGuestId: guest.id,
                eventGuestEmail: guest.ev_email, // for preview only
                title: row[selectedNotificationTitleHeader.value],
                content: row[selectedNotificationContentHeader.value],
                scheduledAt: DateTime.fromJSDate(
                  new Date(
                    Math.round(
                      (row[selectedNotificationScheduledAtHeader.value] -
                        25569) *
                        86400 *
                        1000
                    )
                  )
                )
                  .setZone("Etc/GMT")
                  .toFormat("yyyy-MM-dd HH:mm:ss"),
              });
            }
          });
        });
        enableSaveButton.value = true;
      }
    });

    const previewHeaders = ref([
      { text: "Event Guest", value: "eventGuestEmail" },
      { text: "Title", value: "title" },
      { text: "Content", value: "content" },
      { text: "Scheduled At", value: "scheduledAt" },
    ]);

    // handle cancel events
    // triggered when user click the little cross button in v-input-file
    // cancel the whole process and keep the dialog open
    const cancelUploadExcel = async function() {
      // clear stage 1 data
      selectedExcelFile.value = null;
      excelHeaders.value = [];
      excelData.value = [];
      excelUploading.value = false;
      excelUploadStatus.value = "Please upload an Excel file";
      guestList.value = [];
      // clear stage 2 data
      selectedGuestHeader.value = null;
      selectedExcelHeader.value = null;
      // clear stage 3 data
      selectedNotificationTitleHeader.value = null;
      selectedNotificationContentHeader.value = null;
      selectedNotificationScheduledAtHeader.value = null;
      currentNotificationArray.value = [];
      enableSaveButton.value = false;
      // reset stage
      await root.$nextTick();
      stage.value = 0;
    };

    // triggered when user click the cancel button in the dialog
    // clear all editing data
    const cancelAddNotification = function() {
      cancelUploadExcel();
      showAddDialog.value = false;
    };

    // triggered when user click the add button at the top-right corner
    // open the dialog
    const addNotification = function() {
      stage.value = 0;
      showAddDialog.value = true;
    };

    // triggered when user click the delete button in each row of data table
    const pendingDelete = ref(null);
    const confirmDelete = function(item) {
      pendingDelete.value = item;
      if (!item && selectedSingleNotification.value.length > 0) {
        pendingDelete.value = selectedSingleNotification.value;
      }
      showDeleteDialog.value = true;
    };
    const cancelDelete = function() {
      pendingDelete.value = null;
      showDeleteDialog.value = false;
    };
    const deleteNotification = async function() {
      overlay.value = true;
      if (Array.isArray(pendingDelete.value)) {
        try {
          const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
          await axios
            .create({
              headers: {
                Authorization: window.localStorage.getItem("feathers-jwt"),
              },
            })
            .post(`${prefixUrl}/batch-update-api/batch-update`, {
              service: "single-notification",
              instances: pendingDelete.value,
              operation: "delete",
            });
          pendingDelete.value = null;
          selectedSingleNotification.value = [];

          // Refresh the data table by making a new find call
          fetchNotification();

          showDeleteDialog.value = false;
          root.$store.dispatch("showSnackBar", "Delete successful");
        } catch (error) {
          root.$store.dispatch("showSnackBar", error.message);
        }
      } else {
        pendingDelete.value.remove().then(async () => {
          pendingDelete.value = null;

          // Refresh the data table by making a new find call
          fetchNotification();

          showDeleteDialog.value = false;
          root.$store.dispatch("showSnackBar", "Delete successful");
        }, root.$handleFeatherError.bind(root));
      }
      overlay.value = false;
    };

    // triggered when user click the save button in the dialog
    const enableSaveButton = ref(false);
    const confirmSave = function() {
      showSaveDialog.value = true;
    };
    const cancelSave = function() {
      showSaveDialog.value = false;
    };
    const saveNotification = async function() {
      overlay.value = true;
      try {
        const singleNotificationObjectArray = currentNotificationArray.value.map(
          (notification) => new SingleNotification(notification)
        );
        const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
        await axios
          .create({
            headers: {
              Authorization: window.localStorage.getItem("feathers-jwt"),
            },
          })
          .post(`${prefixUrl}/batch-update-api/batch-update`, {
            service: "single-notification",
            instances: singleNotificationObjectArray,
            operation: "create",
          });

        // Refresh the data table by making a new find call
        fetchNotification();

        showSaveDialog.value = false;
        showAddDialog.value = false;
        cancelUploadExcel();
        root.$store.dispatch("showSnackBar", "Save successful");
      } catch (error) {
        showSaveDialog.value = false;
        root.$store.dispatch("showSnackBar", error.message);
      }
      overlay.value = false;
    };

    return {
      DateTime,
      getFileUrl: root.$getFileURL,

      TIME_ZONE,
      overlay,
      showAddDialog,
      showSaveDialog,
      showDeleteDialog,
      stage,

      search: ref(""),

      headers,
      notificationItems,
      isNotificationPending,
      selectedSingleNotification,

      selectedExcelFile,
      excelHeaders,
      excelUploading,
      excelUploadStatus,
      uploadExcel,

      cancelUploadExcel,
      cancelAddNotification,
      addNotification,

      selectedGuestHeader,
      selectedExcelHeader,
      availableGuestHeaders,

      selectedNotificationTitleHeader,
      selectedNotificationContentHeader,
      selectedNotificationScheduledAtHeader,
      currentNotificationArray,
      previewHeaders,

      pendingDelete,
      confirmDelete,
      cancelDelete,
      deleteNotification,

      enableSaveButton,
      confirmSave,
      cancelSave,
      saveNotification,
    };
  },
};
</script>
